<template>
    <modal @closed="$emit('closed')">
        <h3 slot="header">{{ title }}</h3>
        <slot>
            <p>This is a premium feature! Interested in using this feature when it launches? Enter your info below and we'll notify you when it's ready.</p>
        </slot>
        <form class="interest-form">
            <label>First Name</label>
            <input type="text" placeholder="First Name" v-model="firstName" required>
            
            <label>Last Name</label>
            <input type="text" placeholder="Last Name" v-model="lastName" required>
            
            <label>Email</label>
            <input type="email" placeholder="Email" v-model="email" required>
            
            <button @click.prevent.stop="send" :disabled="sending">Keep Me Posted</button>
        </form>
    </modal>
</template>

<script>
import CloseIcon from 'src/components/icons/Close';
import api from 'src/api';

export default {
    props: {
        title: {
            type: String,
            default: 'Premium Feature',
        },
        feature: {
            type: String,
        },
        meta: {
            type: Object,
        },
    },
    data() {
        return {
            sending: false,
            firstName: '',
            lastName: '',
            email: '',
        };
    },
    methods: {
        send() {
            this.sending = true;

            api.post('premium', {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                meta: this.meta,
                feature: this.feature,
            })
                .then(() => {
                    this.$emit('closed');
                })
                .catch(() => {
                    this.sending = false;
                });
        },
    },
};
</script>